module.exports = __webpack_public_path__ + "img/poster-1.ed46c5dd.jpg";